import React from 'react';
import { Tag }              from 'antd';
import { LAG_GS } from 'AppConfig/Config';
import { useSelector }                                                   from 'react-redux';
import { getDePseudonymed, getDePseudonymedResultIds, userContainsRole } from 'Redux/Query';

export const PseudoName = ({ value, record }) => {
  const dePseudonymedResultIds = useSelector(getDePseudonymedResultIds);
  const dePseudonymed = useSelector(getDePseudonymed);
  const checkUserRole = useSelector(userContainsRole);

  if(!record.result) {
    return <i>--</i>;
  }
  const { pseudonym } = record.result;
  if((dePseudonymed.includes(pseudonym?.key) || dePseudonymedResultIds.includes(record.result.id)) && checkUserRole( [ LAG_GS ])) {
    return (
      <React.Fragment>
        { (pseudonym) ? <Tag color="blue" style={{ marginBottom: 5 }}>{ pseudonym.key }</Tag> : <i>---</i> }<br />
        <div className="dePseudonymed">
          { record.careProvider.name } <br />
          { record.careProvider.identNumber }
          {(record.careProvider.destinationKey) ? <React.Fragment><br />{ `(${record.careProvider.destinationKey})` }</React.Fragment> : '' }
        </div>
      </React.Fragment>
    )
  }

  return (pseudonym) ?
    <Tag color="blue" style={{ marginBottom: 5 }}>{ pseudonym.key }</Tag> :
    <i>--</i>;
}
